import React, { Fragment, useEffect, useState } from 'react'
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger
} from '../../Common/ui/accordion'
import { IoChevronDown, IoChevronForward } from 'react-icons/io5'
import { MdOutlineAddBox } from 'react-icons/md'
import { RxTrash } from 'react-icons/rx'
import { IconButton } from '@mui/material'
import DropdownTextInput from '../../Common/ui/DropdownTextInput'
import PropTypes from 'prop-types'
import Input from '../../Common/ui/input'
import PhoneNumber from '../../Common/ui/PhoneNumber'
// import { Checkbox } from '../../Common/ui/checkbox'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import Stack from '@mui/material/Stack'
import Divider from '@mui/material/Divider'
import { Button } from '../../Common/ui/button'
import { CrossCircledIcon } from '@radix-ui/react-icons'
import Box from '@mui/material/Box'
import { useOnboardingStore, useProfileScreenStore } from '../../Containers/Onboarding/Store/OnboardingStore'
// import { Country, State } from 'country-state-city'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import * as InputEntities from '../../Entities/InputTypes'
import Tooltip from '@mui/material/Tooltip'
import CustomSelect from 'src/Common/ui/CustomSelect'
import * as EndPoints from '../../Entities/EndPoints'
import Axios from 'src/Axios'
// import * as OnboardEntity from '../../Entities/OnBoardingContainerTypes'

const BoardComposition = ({ boardsFormData, setBoardsFormData, errors, control, reset, trigger, setError, clearErrors, register, setValue }) => {
    const [ activeAccordion, setActiveAccordion ] = useState(`accorrd-${boardsFormData.length - 1}`)
    const [ isDeleteModal, setIsDeleteModal ] = React.useState(false)
    const createBoardComposition = useOnboardingStore((state) => state.createBoardComposition)
    const getBoardComposition = useOnboardingStore((state) => state.getBoardComposition)
    const { getBoardCompositionData } = useOnboardingStore()
    const orgId = localStorage.getItem('orgId')
    const [ duplicateBoardFormData, setDuplicateBoardFormData ] = useState([])
    const { t } = useTranslation()
    const { getCountryData, getCountry } = useProfileScreenStore()
    const [ country, setCountry ] = useState([])
    const [ stateArrayData, setStateArrayData ] = useState([])
    const [ cityArrayData, setCityArrayData ] = useState([])

    useEffect(() => {
        const fetchBoardComposition = async () => {
            await getBoardComposition(orgId)
        }

        fetchBoardComposition()
    }, [orgId])

    useEffect(() => {
        if (getBoardCompositionData.length > 0) {
            const userRequests = getBoardCompositionData.map((data) => ({
                firstName: data?.firstName || '',
                middleName: data?.middleName || '',
                lastName: data?.lastName || '',
                emailId: data?.emailId || '',
                phoneNumber: data?.phoneNo || '',
                phoneCode: data?.phoneCode || '',
                phoneCountryCode: data?.phoneCountryCode || '',
                isActive: data?.isActive || false,
                userId: data?.userId || 0,
                orgId: data?.organizationId || orgId,
                address: data?.address || '',
                city: Number(data?.city) || '',
                state: Number(data?.state) || '',
                country: Number(data?.country) || '',
                pincode: data?.pincode || '',
                status: data?.status || 1
            }))
            setBoardsFormData(userRequests)
            setDuplicateBoardFormData(userRequests)
        }
    }, [ getBoardCompositionData, orgId ])

    const handleAddBoard = async () => {
        const isValid = await trigger()
        if (isValid) {
            const userRequests = boardsFormData?.map((data) => ({
                firstName: data?.firstName || '',
                middleName: data?.middleName || '',
                lastName: data?.lastName || '',
                emailId: data?.emailId || '',
                phoneNo: data?.phoneNumber || '',
                phoneCode: data?.phoneCode || '',
                phoneCountryCode: data?.phoneCountryCode || '',
                isActive: false,
                userId: data?.userId || 0,
                orgId,
                address: data?.address || '',
                city: data?.address ? Number(data?.city) : '',
                state: data?.address ? Number(data?.state) : '',
                country: data?.address ? Number(data?.country) : '',
                pincode: data?.address ? data?.pincode : '',
                status: data?.status || 1
            }))
            const boardCompositionFormData = new FormData()
            const appendFormData = (formData, data, parentKey = '') => {
                if (data && typeof data === 'object' && !Array.isArray(data)) {
                    Object.keys(data).forEach(key => {
                        const newKey = parentKey ? `${parentKey}[${key}]` : key
                        appendFormData(formData, data[key], newKey)
                    })
                } else if (Array.isArray(data)) {
                    data.forEach((item, index) => {
                        const newKey = `${parentKey}[${index}]`
                        appendFormData(formData, item, newKey)
                    })
                } else {
                    formData.append(parentKey, data)
                }
            }

            userRequests.forEach((obj, index) => {
                Object.keys(obj).forEach(key => {
                    const newKey = `createUser[${index}][${key}]`
                    appendFormData(boardCompositionFormData, obj[key], newKey)
                })
            })

            createBoardComposition(boardCompositionFormData, 1)
                .then((response) => {
                    if (response?.data) {
                        getBoardComposition(orgId)
                            .then((res) => {
                                if (res?.data) {
                                    const modifyData = [ ...res.data?.map((mapDt, mapIdx) => { return { ...mapDt, phoneNumber: mapDt?.phoneNo } }), {
                                        firstName: '',
                                        middleName: '',
                                        lastName: '',
                                        emailId: '',
                                        phoneNumber: '',
                                        phoneCode: '',
                                        phoneCountryCode: '',
                                        isActive: false,
                                        address: '',
                                        city: '',
                                        state: '',
                                        country: '',
                                        pincode: '',
                                        status: 1
                                    }]

                                    setBoardsFormData([...modifyData])
                                    setDuplicateBoardFormData([...modifyData])
                                    reset()
                                }
                            })
                    }
                    toast.success(<p className='w-[100%] flex flex-row justify-evenly items-center' ><p>{t('Management team member added successfully')}</p></p>, {
                        position: 'top-right',

                        theme: 'light'
                    })
                })
                .catch((err) => {
                    console.error('Error posting board composition data:', err)
                    toast.error(<p className='w-[70%] flex flex-row justify-evenly items-center' ><p color='hsl(var(--card))'>{t('Error in adding management team try again!')}</p></p>, {
                        position: 'top-right', theme: 'light'
                    })
                })
        }
    }

    useEffect(() => {
        setActiveAccordion(`accorrd-${boardsFormData.length - 1}`)
    }, [duplicateBoardFormData])

    const handleDeleteBoard = () => {
        const updatedBoards = boardsFormData.filter((_, idx) => idx !== removeBMindex)
        setBoardsFormData(updatedBoards)

        const boardCompositionFormData = new FormData()
        const userRequests = { ...boardsFormData[removeBMindex] }

        userRequests.status = InputEntities.INACTIVE
        userRequests.pincode = userRequests?.pincode || ''

        Object.keys(userRequests).forEach((key) => {
            boardCompositionFormData.append(`createUser[0][${key}]`, userRequests[key])
        })

        createBoardComposition(boardCompositionFormData, 1)
            .then((response) => {
                if (response?.data) {
                    toast.success(<p>{t('Management team member deleted successfully')}</p>, {
                        position: 'top-right',

                        theme: 'light'
                    })
                }
            })
            .catch((err) => {
                console.error('Error deleting board composition:', err)
                toast.error(<p>{t('Error deleting management team member. Try again!')}</p>, {
                    position: 'top-right',
                    hideProgressBar: true,
                    theme: 'light'
                })
            })
        handleCloseDeleteModal()
    }

    const onValueChange = (value, keyName, index) => {
        if (keyName === 'phoneNumber') {
            setBoardsFormData([...boardsFormData].map((item, idx) => {
                if (idx === index) {
                    return {
                        ...item,
                        phoneCountryCode: value.countryCode,
                        phoneCode: value.phNumberCode,
                        phoneNumber: value.phNumber
                    }
                } else {
                    return item
                }
            }))
        } else {
            setBoardsFormData([...boardsFormData].map((item, idx) => {
                if (idx === index) {
                    return { ...item, [keyName]: value }
                } else {
                    return item
                }
            }))
        }
    }

    const handleCloseDeleteModal = () => {
        setIsDeleteModal(false)
    }

    const [ removeBMindex, setRemoveBMindex ] = useState(null)
    const handleOpenDeleteModal = (index) => {
        setIsDeleteModal(true)
        setRemoveBMindex(index)
    }
    const instance = Axios.getInstance()

    useEffect(() => {
        if (boardsFormData?.length > 0) {
            const fetchStates = async () => {
                const allStates = await Promise.all(
                    boardsFormData.map(async (mapDt) => {
                        if (mapDt?.country) {
                            try {
                                const response = await instance.get(
                                    `${EndPoints.API_ENDPOINT}/masterController/states?id=${mapDt?.country}`
                                )
                                return response?.data || []
                            } catch (error) {
                                console.error('Error fetching states:', error)
                            }
                        }
                        return []
                    })
                )
                setStateArrayData(allStates)
            }

            const fetchCities = async () => {
                const allCities = await Promise.all(
                    boardsFormData.map(async (mapDt) => {
                        if (mapDt?.state) {
                            try {
                                const response = await instance.get(
                                    `${EndPoints.API_ENDPOINT}/masterController/cities?id=${mapDt?.state}`
                                )
                                return response?.data || []
                            } catch (error) {
                                console.error('Error fetching cities:', error)
                            }
                        }
                        return []
                    })
                )
                setCityArrayData(allCities)
            }

            fetchStates()
            fetchCities()
        }
    }, [boardsFormData])

    useEffect(() => {
        getCountry()
    }, [])

    useEffect(() => {
        if (getCountryData?.length > 0) {
            setCountry(getCountryData)
        }
    }, [getCountryData?.length])

    const handleAddress = (value, field, idx) => {
        const baseField = field.split('_')[0]
        setBoardsFormData(prevData =>
            prevData.map((mapDt, mapIdx) => {
                if (mapIdx === idx) {
                    return { ...mapDt, [baseField]: Number(value) }
                } else {
                    return mapDt
                }
            })
        )
    }

    return (
        <div className='mt-2'>
            <Accordion type="single" collapsible value={activeAccordion} onValueChange={(e) => setActiveAccordion(e)}>
                {boardsFormData?.map((item, index) => (
                    <AccordionItem className='mt-2' key={`accorrd-${index}`} value={`accorrd-${index}`}>
                        <AccordionTrigger
                            className='py-2 px-2'
                            hideIcon
                            headerClassName='onboard-accordion-header-container pr-2 hover-container'
                            headerChild={<Fragment>
                                {boardsFormData?.length - 1 === index && (<div className='my-auto'>
                                    <Tooltip title="Delete Member" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                        <IconButton sx={{ padding: 0.3 }} className='delete-icon' onClick={() => handleOpenDeleteModal(index)}><RxTrash className='text-danger mr-4' /></IconButton>
                                    </Tooltip>
                                </div>)}
                                {boardsFormData?.length - 1 !== index && (<div className='my-auto'>
                                    <Tooltip title="Delete Member" placement="right-start" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                        <IconButton sx={{ padding: 0.3 }} className='delete-icon' onClick={() => handleOpenDeleteModal(index)}><RxTrash className='text-danger mr-4' /></IconButton>
                                    </Tooltip>
                                </div>)}
                                {boardsFormData?.length - 1 === index && (<div className='my-auto ml-auto'>
                                    <Tooltip title="Add Member" placement="right-start" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                        <IconButton sx={{ padding: 0.3 }} onClick={handleAddBoard}><MdOutlineAddBox fill={'hsl(var(--primary))'} className='mr-4' /></IconButton>
                                    </Tooltip>

                                </div>)}
                            </Fragment>}
                        >
                            <div className='flex'>
                                <div className='my-auto mr-2'>
                                    {activeAccordion === `accorrd-${index}`
                                        ? <IoChevronDown className='onboard-accordion-chevron' />
                                        : <IoChevronForward className='onboard-accordion-chevron' />}
                                </div>
                                <p className='my-auto'>{item?.firstName || item?.middleName || item?.lastName ? `${item?.firstName} ${item?.middleName || ''} ${item?.lastName || ''}` : t('Management Team')}</p>
                            </div>
                        </AccordionTrigger>
                        <AccordionContent>
                            <div className='my-2 mx-2 '>
                                <div className='flex w-full gap-[20px] min-h-[70px] mt-4'>
                                    <div className='w-[33%]'>
                                        <DropdownTextInput required name={'dropText' + index} placeholder={t('Enter First Name')} label={t('First Name')} value={item?.firstName}
                                            onValueChange={(value) => onValueChange(value, 'firstName', index)}
                                            rules={{
                                                required: t('First Name is required'),
                                                validate: (value) => {
                                                    const titleRegex = /^(Mr\.|Mrs\.|Ms\.|Mx\.|Dr\.)\s*/i
                                                    const nameWithoutTitle = value.replace(titleRegex, '').trim()
                                                    const regex = /^[A-Za-z.]+$/
                                                    if (!regex.test(nameWithoutTitle)) {
                                                        return 'First Name must contain only letters'
                                                    }
                                                    if (nameWithoutTitle.length > 50) {
                                                        return 'First Name must not exceed 50 characters'
                                                    }
                                                    return true
                                                }
                                            }}
                                            control={control} errors={errors} setError={setError} clearErrors={clearErrors}/>
                                    </div>
                                    <div className='w-[33%]'>
                                        <Input name={'midName' + index} placeholder={t('Enter Middle Name')} label={t('Middle Name')} value={item?.middleName} onValueChange={({ target: { value } }) => onValueChange(value, 'middleName', index)}
                                            rules={{
                                                validate: (value) => {
                                                    const regex = /^[A-Za-z]+$/
                                                    const middleName = value?.trim()
                                                    if (!regex.test(value)) {
                                                        return t('Middle Name must contain only letters')
                                                    }
                                                    if (middleName?.length > 30) {
                                                        return t('Middle Name must not exceed 30 characters')
                                                    }
                                                    return true
                                                }
                                            }} control={control} errors={errors} setError={setError} clearErrors={clearErrors}/>
                                    </div>
                                    <div className='w-[33%]'>
                                        <Input required name={'lastName' + index} placeholder={t('Enter Last Name')} label={t('Last Name')} value={item?.lastName} onValueChange={({ target: { value } }) => onValueChange(value, 'lastName', index)}
                                            rules={{
                                                required: t('Last Name is required'),
                                                validate: (value) => {
                                                    const regex = /^[A-Za-z]+$/
                                                    const LastName = value.trim()
                                                    if (!value.trim()) {
                                                        return t('Last Name cannot be empty spaces')
                                                    }
                                                    if (!regex.test(value)) {
                                                        return t('Last Name must contain only letters')
                                                    }
                                                    if (LastName.length > 30) {
                                                        return t('Last Name must not exceed 30 characters')
                                                    }
                                                    return true
                                                }
                                            }}
                                            control={control} errors={errors} setError={setError} clearErrors={clearErrors} />
                                    </div>
                                </div>
                                <div className='flex w-full gap-[20px] min-h-[70px]'>
                                    <div className='w-[31.5%]'>
                                        <Input required name={'emailId-' + index} userId={item?.userId} placeholder={t('Enter Email Id')} label={t('Email ID')} value={item?.emailId} onValueChange={({ target: { value } }) => onValueChange(value, 'emailId', index)}
                                            rules={{
                                                validate: (value) => {
                                                    const regexEmail = /^[a-zA-Z0-9.+-_%]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
                                                    if (!value) {
                                                        return t('Email is required')
                                                    } else if (!regexEmail.test(value)) {
                                                        return t('Enter a valid email')
                                                    }
                                                },
                                                required: t('Email is required')
                                            }} control={control} errors={errors} setError={setError} clearErrors={clearErrors}/>
                                    </div>
                                    <div className='w-[31%]' key={index}>
                                        <PhoneNumber
                                            name={`phoneNumber${index}`}
                                            // value={{ phoneNumber: item?.phoneNo }}
                                            value={item?.phoneNumber ? `${item?.phoneCode || ''}${item?.phoneNumber}` : ''}
                                            control={control}
                                            placeholder={t('Enter phone number')}
                                            label={t('Phone Number')}
                                            register={register}
                                            rules={{
                                                validate: (value) => {
                                                    if (value) {
                                                        // const trimmedValue = value.startsWith('+91') ? value.slice(3).trim() : value
                                                        const regexPhone = /^[0-9]{10}$/
                                                        if (!regexPhone.test(value)) {
                                                            return t('Phone number must be 10 digits')
                                                        }
                                                    }
                                                }
                                            }}
                                            errors={errors} setValue={setValue} setError={setError} clearErrors={clearErrors}
                                            onValueChange={(value) => onValueChange(value, 'phoneNumber', index)}
                                            userId={+item?.userId}
                                        />
                                    </div>
                                    {/* <div className='h-[94px] w-[33%] flex items-center'>
                                        <div className='w-[100%] flex'>
                                            <Checkbox disabled name={'isActive' + index} checked={!!item?.isActive} onCheckedChange={(e) => onValueChange(e, 'isActive', index)} />
                                            <label className='grc-label ml-2'>{t('Do you want to send notification?')}</label>
                                        </div>
                                    </div> */}
                                </div>
                                <div className='flex w-full gap-[20px] min-h-[70px] mt-4'>
                                    <div className='w-[66.3%]'>
                                        <Input name={'address' + index} className='!w-[98%]' type='text' placeholder={t('Enter apartment/house/street')} label={t('Apartment/House/Street')} value={item?.address} onValueChange={({ target: { value } }) => onValueChange(value, 'address', index)}
                                            rules={{
                                                validate: (value) => {
                                                    if (value) {
                                                        const address = value.trim()
                                                        if (!value.trim()) {
                                                            return t('Address cannot be empty spaces')
                                                        }
                                                        if (address.length > 50) {
                                                            return t('Address must not exceed 50 characters')
                                                        }
                                                        return true
                                                    }
                                                    return true
                                                }
                                            }}
                                            control={control} errors={errors}/>
                                    </div>
                                    <div className='w-[33%]'>
                                        <CustomSelect
                                            name={`country${index}`}
                                            disabled={!item?.address}
                                            label={t('Country')}
                                            options={country}
                                            value={item?.address ? item?.country : ''}
                                            onValueChange={(value) => handleAddress(value, 'country', index)}
                                            placeholder={t('Select country')}
                                            mapIdx={index}
                                            errors={errors}
                                            control={control}
                                            required={item.address}
                                            rules={{ required: item?.address ? 'Country is required' : false }}
                                        />
                                    </div>
                                </div>
                                <div className='flex w-full gap-[20px] min-h-[70px]'>
                                    <div className='w-[33%]'>
                                        <CustomSelect
                                            name={`state${index}`}
                                            disabled={!item?.address}
                                            label={t('State')}
                                            options={Array.isArray(stateArrayData[index]) ? stateArrayData[index] : []}
                                            value={item?.address ? item?.state : ''}
                                            onValueChange={(value) => handleAddress(value, 'state', index)}
                                            placeholder={t('Select State')}
                                            mapIdx={index}
                                            errors={errors}
                                            control={control}
                                            required={item.address}
                                            rules={{ required: item?.address ? 'State is required' : false }}
                                        />
                                    </div>
                                    <div className='w-[32%]'>
                                        <CustomSelect
                                            name={`city${index}`}
                                            disabled={!item?.address}
                                            label={t('City')}
                                            options={Array.isArray(cityArrayData[index]) ? cityArrayData[index] : []}
                                            value={item?.address ? item?.city : ''}
                                            onValueChange={(value) => handleAddress(value, 'city', index)}
                                            placeholder={t('Select City')}
                                            mapIdx={index}
                                            errors={errors}
                                            control={control}
                                            required={item.address}
                                            rules={{ required: item?.address ? 'City is required' : false }}
                                        />
                                    </div>
                                    <div className='w-[33%]'>
                                        <Input disabled={!item?.address} name={'pincode' + index} type='number' placeholder={t('Enter pin code')} label={t('Pin code')} value={!item?.address ? '' : item?.pincode} onValueChange={({ target: { value } }) => onValueChange(value, 'pincode', index)}
                                            required={item?.address}
                                            rules={item.address
                                                ? {
                                                    required: t('Pincode is required'),
                                                    validate: (value) => {
                                                        if (value) {
                                                            if (item?.address) {
                                                                if (!/^\d{6}$/.test(value)) {
                                                                    return t('Pincode must be exactly 6 digits')
                                                                }
                                                                return true
                                                            } else {
                                                                return true
                                                            }
                                                        }
                                                    }
                                                }
                                                : {}} control={control} errors={errors} />
                                    </div>
                                </div>
                            </div>
                        </AccordionContent>
                    </AccordionItem>
                ))}
            </Accordion>
            <Dialog open={isDeleteModal} onClose={handleCloseDeleteModal}>
                <Box sx={{ width: 400 }} >
                    <DialogTitle sx={{ padding: '0px 10px 0px 10px', display: 'flex', alignItems: 'center', backgroundColor: 'hsl(var(--destructive))', flexDirection: 'row', height: '40px', justifyContent: 'space-between' }}>
                        <div style={{ fontSize: '20px', fontWeight: 'bold', color: 'hsl(var(--card))' }}>{t('Delete Confirmation')}</div>
                        <CrossCircledIcon onClick={() => handleCloseDeleteModal()} style={{ height: '30px', width: '30px', fontWeight: 'bold', color: 'hsl(var(--card))', cursor: 'pointer' }} />
                    </DialogTitle>
                    <DialogContent>
                        <Stack direction="column" spacing={2}>
                            <DialogContentText style={{ fontWeight: 'bold', marginTop: '10px' }} id="alert-dialog-description">
                                {t('You are about to delete the management team member')}
                            </DialogContentText>
                            <DialogContentText style={{ fontWeight: 'bold', display: 'flex' }} id="alert-dialog-description">
                                <p>{t('Are you Sure? ')}</p>
                                <p style={{ color: 'hsl(var(--destructive))', fontWeight: 'bold' }}>{t('There is no Undo')}</p>
                            </DialogContentText>
                        </Stack>
                    </DialogContent>
                    <Divider />
                    <DialogActions style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'flex-start' }}>
                        <Button variant='destructive' onClick={() => handleDeleteBoard()}>{t('Yes')}</Button>
                        <Button variant="outline" onClick={() => handleCloseDeleteModal()}>{t('No')}</Button>
                    </DialogActions>
                </Box>
            </Dialog>
        </div>
    )
}

BoardComposition.propTypes = {
    boardsFormData: PropTypes.array,
    setBoardsFormData: PropTypes.func,
    errors: PropTypes.object,
    control: PropTypes.any,
    reset: PropTypes.func,
    trigger: PropTypes.func
}

export default BoardComposition
